import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import { PageContext } from "../../Context/PageContext";
import { supabase } from "../../../supabaseClient";
import Questionario from "../Questionario/Questionario";

function Thankyou() {

    let {setPage , nome, setNome, profissao, setProfissao, email, setEmail, codigo} = useContext(PageContext);

    const [insertedCode, setInsertedCode] = useState("");

    const [exameAtual, setExameAtual] = useState(0);

    const [enableRegisterButton, setEnableRegisterButton] = useState(["none",.5]);

    const [greenCheckStateList, setGreenCheckStateList] = useState([]);

    const {answerList} = useContext(PageContext);

    let listaDeRespostasLocal = answerList;

    //Inicialização e atualização da lista de checks verdes das perguntas
    let greenCheckAnswerList = []


    useEffect(() => {

    },[exameAtual]);

    useEffect(() => {
        if(nome.length < 1 || profissao.length < 1 || email.length < 1 || insertedCode.length < 1){
            setEnableRegisterButton(["none", .5]);
            return;
        }
        if(insertedCode != codigo){
            setEnableRegisterButton(["none", .5]);
            return;
        }

        setEnableRegisterButton(["auto", 1]);
        }
            
    , [nome, profissao, email, insertedCode]); // Array vazio garante que o listener só seja criado no "mount"

    return(
        <MasterContainer>
            <MainContent>
            <Cabecalho>
                <span>Pesquisa acadêmica</span>
                {greenCheckStateList[exameAtual]}
            </Cabecalho>

            <SegundaSecao>
                <CampoPergunta>
                    <TextoNegrito>Obrigado pela sua participação!</TextoNegrito>
                    <br/>
                    Estamos trabalhando duro para criar soluções que impactarão positivamente na saúde e na vida das pessoas.
                    <br/><br/>

                    <TextoNegrito>Obrigado por ser parte disso!</TextoNegrito>

                    <br/>
                    Fim do questionário. Essa janela já pode ser fechada.
 
                </CampoPergunta>

            </SegundaSecao>
        </MainContent>

        </MasterContainer>
    )
}

export default Thankyou;

const MasterContainer = styled.div`
    display: flex;
    //border: solid;
    justify-content: center;
    align-items: start;
    margin-top: 10px;
    width: 950px;
    min-height: 50vh

`

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    //border: solid 1px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    margin-right: 0px;

`

const Cabecalho = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid;
    font-weight: bold;
    font-size: 24pt;
    width: 800px;
    margin-bottom: 0px;
`

const PrimeiraSecao = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid 1px;
    //font-weight: bold;
    border-radius: 5px;
    padding: 10px 0;
    //background-color: rgba(0,0,0,.7);
    //color: white;
    width: 800px;
`

const SegundaSecao = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    margin-top: 10px;
    font-size: 14pt;
    //border: solid;
    //font-weight: bold;
    width: 800px;
`

const CampoPergunta = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    flex-direction: column;
    //border: solid;
    //font-weight: bold;
    margin-top: 20px;
    width: 800px;

`

const TextoNegrito = styled.span`
    font-weight: bold;
`

const ContainerBotoes = styled.div`
    display: flex;
    margin-top: 50px;

`
const AnteriorBotao = styled.div`
    padding: 10px 15px;
    background-color: rgba(29, 125, 189, 0.9);
    color: white;
    font-weight:  bold;
    cursor: pointer;
    transition: .2s ease-in-out;
    border-radius: 5px;
    font-size: 14pt;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    opacity: ${props => props.opacit};
    pointer-events: ${props => props.eventEnabler};


    &:hover {
        //transform: translate(0px, -5px);
        //box-shadow: 0px 2px 2px black;
        scale: 1.1;
    }

    &:active {
        //transform: translate(0px, 0px);
        //box-shadow: 0px 0px 0px black;
        scale: 1.0;
        opacity: .7;
    }

`

const TextInputBox = styled.span`
    font-weight: bold;
    margin-right: 15px;
    font-size: 14pt;
    width: 170px;

`

const SelectBox = styled.select`
    cursor: pointer;
    border: none;
    border-bottom: 1px solid;
    font-size: 14pt;
    padding: 5px 0px;
    text-align: center;
    width: 200px;
`

const InputBox = styled.input`
    cursor: pointer;
    border: none;
    border-bottom: 1px solid;
    font-size: 12pt;
    padding: 5px 0px;
    text-align: center;
`

const CampoResposta = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    flex-wrap: wrap;
    flex-direction: column;
    //border: solid;
    //font-weight: bold;
    margin: 10px 0px;

`

const Resposta = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid;
    //font-weight: bold;
    //width: 230px;
    transition: .3s ease-in-out;
    border-radius: 5px;
    padding: 5px;

    &:hover {
        background-color: rgba(29, 125, 189, 0.9);
        color: white;
    }
`

const LinhaDeCampo = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid;
    width: 360px;
    //font-weight: bold;
`

const Campo = styled.div`
    display: flex;
    padding: 5px 10px;
    align-items: center;
    justify-content: start;
    //border: solid 1px;
    width: 190px;
    font-size: 14pt;
    //font-weight: bold;
`
